module.exports = __webpack_public_path__ + "media/images/flags/gw-b60d397e09401e498f1bc0d78d851576.svg";